import { OrcamentoApi } from "app/api/classes/OrcamentoApi"
import microuniversoApi from "app/api/microuniversoApi"
import globalMU from "globalMU"

export type simularDescontoItemParams = {
  percentualDesconto: number,
  preco: number,
  preservaDescontoModificadoManualmente: boolean,
  preservaDesconto: boolean,
  precoUnitarioTabela: number,
  identificadorItem: number,
  identificadorOrcamento: string,
  percentualBonificacao: number,
  percentualDescontoOrcamento: number,

}

export async function simularDescontoItem(params: simularDescontoItemParams): Promise<OrcamentoApi.SimularDescontoResposta> {
  const percentualAlterado = () => globalMU.isNotNullOrEmpty(params.percentualDesconto)

  const precoAlterado = () => globalMU.isNotNullOrEmpty(params.preco)

  const preservaDescontoAPartirDoPercentual = () => params.preservaDescontoModificadoManualmente ? params.preservaDesconto :
    params.percentualDesconto > 0 ? true :
      params.percentualDesconto == 0 ? false : params.preservaDesconto

  const preservarDescontoAPartirDoPreco = () => params.preservaDescontoModificadoManualmente ? params.preservaDesconto :
    params.preco < params.precoUnitarioTabela ? true : false

  const preservaDesconto = () => percentualAlterado() ? preservaDescontoAPartirDoPercentual() :
    precoAlterado() ? preservarDescontoAPartirDoPreco() : false


  const dados = await microuniversoApi.Orcamento.simularDesconto({
    codigoObjetoItem: params.identificadorItem,
    identificadorOrcamento: params.identificadorOrcamento,
    percentualBonificacao: params.percentualBonificacao,
    percentualDesconto: params.percentualDesconto,
    percentualDescontoGeralOrcamento: params.percentualDescontoOrcamento,
    preco: params.preco,
    preservaDesconto: preservaDesconto()
  })
  return dados
}